'use client';
var classes = {"root":"m-f85678b6","image":"m-11f8ac07","placeholder":"m-104cd71f","group":"m-11def92b"};

export default classes;
//# sourceMappingURL=Avatar.module.mjs.map
